export const movies = [
  {
    id: 'm01',
    title: '星海归途',
    category: 'movie',
    genres: ['科幻', '冒险'],
    region: '中国',
    year: 2024,
    rating: 8.7,
    heat: 9620,
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20film%20poster%20of%20a%20lone%20astronaut%20before%20a%20glowing%20blue%20nebula%20deep%20navy%20and%20warm%20orange%20tones%20dramatic%20lighting%20ultra%20detailed%20digital%20painting%2C%20vertical%20composition&width=400&height=600&seq=poster-01&orientation=portrait',
    director: '陆川',
    actors: ['张亦驰', '林清和', '周牧'],
    duration: '128分钟',
    synopsis: '一次深空任务失联后，宇航员独自穿越未知星域寻找回家的航道。影片以宏大的宇宙想象包裹着关于孤独、信念与重逢的细腻情感，是近年来国产科幻的诚意之作。',
  },
  {
    id: 'm02',
    title: '长夜将至',
    category: 'movie',
    genres: ['悬疑', '犯罪'],
    region: '韩国',
    year: 2024,
    rating: 8.2,
    heat: 8810,
    cover: 'https://readdy.ai/api/search-image?query=moody%20crime%20thriller%20movie%20poster%20of%20a%20rain%20soaked%20city%20street%20at%20night%20with%20a%20silhouette%20figure%20deep%20blue%20shadows%20and%20warm%20orange%20streetlights%2C%20cinematic%20vertical%20poster%20art&width=400&height=600&seq=poster-02&orientation=portrait',
    director: '金成勋',
    actors: ['朴叙俊', '韩素希'],
    duration: '116分钟',
    synopsis: '一桩跨越十年的连环案件，让固执的老刑警与年轻的检察官在漫长的黑夜里并肩追凶。真相每揭开一层，代价都更加沉重。',
  },
  {
    id: 'm03',
    title: '山与海的距离',
    category: 'movie',
    genres: ['剧情'],
    region: '中国',
    year: 2023,
    rating: 8.9,
    heat: 7640,
    cover: 'https://readdy.ai/api/search-image?query=warm%20emotional%20drama%20film%20poster%20of%20a%20person%20standing%20between%20mountain%20and%20sea%20at%20golden%20sunset%20soft%20pastel%20tones%20painterly%20style%2C%20vertical%20cinematic%20composition&width=400&height=600&seq=poster-03&orientation=portrait',
    director: '李睿珺',
    actors: ['周冬雨', '王砚辉'],
    duration: '124分钟',
    synopsis: '生长在内陆山村的父亲与远赴海边打拼的女儿，用一封封未寄出的信跨越了山与海。影片以克制的镜头语言讲述了中国式家庭最深沉的牵挂。',
  },
  {
    id: 'm04',
    title: '追风少年',
    category: 'movie',
    genres: ['运动', '剧情'],
    region: '中国',
    year: 2024,
    rating: 7.8,
    heat: 6410,
    cover: 'https://readdy.ai/api/search-image?query=energetic%20sports%20movie%20poster%20of%20a%20young%20runner%20sprinting%20on%20an%20athletics%20track%20with%20motion%20blur%20warm%20orange%20light%20dramatic%20dynamic%20vertical%20composition&width=400&height=600&seq=poster-04&orientation=portrait',
    director: '陈宇',
    actors: ['刘昊然', '张子枫'],
    duration: '112分钟',
    synopsis: '小镇短跑少年被教练发掘，在伤病与质疑中向省队发起冲击。汗水、友情与不服输的倔强，构成了这个夏天最热血的成长故事。',
  },
  {
    id: 'm05',
    title: '雾都谜案',
    category: 'movie',
    genres: ['悬疑'],
    region: '英国',
    year: 2023,
    rating: 8.4,
    heat: 7230,
    cover: 'https://readdy.ai/api/search-image?query=classic%20mystery%20movie%20poster%20of%20a%20foggy%20victorian%20london%20street%20with%20glowing%20gas%20lamps%20deep%20blue%20mist%20and%20warm%20amber%20light%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-05&orientation=portrait',
    director: '罗伯特·格林',
    actors: ['艾米莉亚·克拉克', '汤姆·希德勒斯顿'],
    duration: '135分钟',
    synopsis: '维多利亚时代的伦敦，一位私家侦探受雇调查一连串离奇失踪案，却逐渐发现线索都指向了自己不愿回首的过去。',
  },
  {
    id: 'm06',
    title: '最后的骑士',
    category: 'movie',
    genres: ['动作', '冒险'],
    region: '美国',
    year: 2024,
    rating: 7.5,
    heat: 9130,
    cover: 'https://readdy.ai/api/search-image?query=epic%20action%20adventure%20movie%20poster%20of%20a%20lone%20armored%20knight%20on%20horseback%20before%20a%20stormy%20sky%20dramatic%20golden%20light%2C%20cinematic%20vertical%20composition%20highly%20detailed&width=400&height=600&seq=poster-06&orientation=portrait',
    director: '丹尼尔·沃克',
    actors: ['克里斯·埃文斯', '安娜·德·阿玛斯'],
    duration: '142分钟',
    synopsis: '王国覆灭后，最后一位骑士带着年幼的继承人穿越战火，只为守护一个早已无人记得的誓言。宏大场面与经典骑士精神的回归。',
  },
  {
    id: 'm07',
    title: '时光信箱',
    category: 'movie',
    genres: ['爱情', '剧情'],
    region: '中国',
    year: 2023,
    rating: 8.1,
    heat: 5830,
    cover: 'https://readdy.ai/api/search-image?query=romantic%20drama%20film%20poster%20of%20a%20vintage%20mailbox%20in%20a%20sunlit%20meadow%20soft%20warm%20tones%20nostalgic%20painterly%20vertical%20composition%20gentle%20bokeh&width=400&height=600&seq=poster-07&orientation=portrait',
    director: '许宏宇',
    actors: ['倪妮', '井柏然'],
    duration: '118分钟',
    synopsis: '一封寄往十年前的信托起两段错位的缘分。关于遗憾与释怀，影片用温柔的笔触告诉观众：有些告别，其实是为了更好的重逢。',
  },
  {
    id: 'm08',
    title: '深海回响',
    category: 'movie',
    genres: ['科幻', '惊悚'],
    region: '美国',
    year: 2024,
    rating: 8.6,
    heat: 9400,
    cover: 'https://readdy.ai/api/search-image?query=deep%20sea%20science%20fiction%20horror%20movie%20poster%20of%20a%20submarine%20in%20dark%20ocean%20depths%20with%20bioluminescent%20blue%20light%20and%20warm%20orange%20accents%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-08&orientation=portrait',
    director: '詹姆斯·卡梅隆',
    actors: ['杰森·莫玛', '赞达亚'],
    duration: '131分钟',
    synopsis: '一支深海科考队在马里亚纳海沟接收到无法解释的声呐回响，随着下潜深度增加，他们遇到的东西正一点点改变着人类的认知。',
  },
  {
    id: 'm09',
    title: '荒野之歌',
    category: 'movie',
    genres: ['冒险', '剧情'],
    region: '澳大利亚',
    year: 2023,
    rating: 7.9,
    heat: 5240,
    cover: 'https://readdy.ai/api/search-image?query=adventure%20drama%20movie%20poster%20of%20a%20traveler%20hiking%20through%20vast%20wild%20australian%20outback%20at%20dawn%20warm%20earthy%20tones%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-09&orientation=portrait',
    director: '米娅·汉森',
    actors: ['休·杰克曼', '玛格特·罗比'],
    duration: '126分钟',
    synopsis: '一场意外的荒野迷失，让一位都市女性重新学会与自然对话。壮阔的内陆风光与孤独的自我救赎交织成一曲荒野之歌。',
  },
  {
    id: 'm10',
    title: '城市微光',
    category: 'movie',
    genres: ['剧情'],
    region: '中国',
    year: 2024,
    rating: 8.3,
    heat: 6900,
    cover: 'https://readdy.ai/api/search-image?query=urban%20drama%20film%20poster%20of%20a%20young%20person%20in%20a%20glowing%20city%20street%20at%20night%20warm%20window%20lights%20deep%20blue%20evening%20sky%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-10&orientation=portrait',
    director: '文晏',
    actors: ['易烊千玺', '马思纯'],
    duration: '115分钟',
    synopsis: '深夜便利店的店员、加班的程序员、送外卖的父亲，三条原本平行的生活轨迹在一场城市停电中意外交会，彼此照亮。',
  },
  {
    id: 'm11',
    title: '无声证词',
    category: 'movie',
    genres: ['犯罪', '悬疑'],
    region: '中国',
    year: 2023,
    rating: 8.5,
    heat: 7420,
    cover: 'https://readdy.ai/api/search-image?query=crime%20thriller%20movie%20poster%20of%20a%20detective%20silhouette%20in%20a%20dark%20interrogation%20room%20single%20warm%20lamp%20deep%20blue%20shadows%2C%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-11&orientation=portrait',
    director: '曹保平',
    actors: ['段奕宏', '周迅'],
    duration: '129分钟',
    synopsis: '一名聋哑证人是唯一目击者，年轻律师必须在她无声的证词中找出真相。影片将悬疑张力与人文关怀融为一体。',
  },
  {
    id: 'm12',
    title: '星际拾荒者',
    category: 'movie',
    genres: ['科幻'],
    region: '美国',
    year: 2024,
    rating: 8.0,
    heat: 8610,
    cover: 'https://readdy.ai/api/search-image?query=science%20fiction%20movie%20poster%20of%20a%20scavenger%20astronaut%20in%20a%20vast%20starship%20graveyard%20warm%20orange%20sunlight%20deep%20blue%20space%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-12&orientation=portrait',
    director: '丹尼斯·维伦纽瓦',
    actors: ['蒂莫西·柴勒梅德', '丽贝卡·弗格森'],
    duration: '138分钟',
    synopsis: '在废弃舰船构成的太空坟场里，拾荒者靠拆解残骸为生。当他发现一艘仍在运转的神秘母舰时，一个庞大的秘密也随之苏醒。',
  },
  {
    id: 't01',
    title: '雾隐江湖',
    category: 'tv',
    genres: ['武侠', '古装'],
    region: '中国',
    year: 2024,
    rating: 9.0,
    heat: 9810,
    cover: 'https://readdy.ai/api/search-image?query=wuxia%20costume%20drama%20poster%20of%20a%20sword%20fighter%20in%20misty%20ancient%20chinese%20mountains%20deep%20blue%20mist%20warm%20orange%20lantern%20light%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-13&orientation=portrait',
    director: '张黎',
    actors: ['肖战', '杨幂'],
    duration: '全40集',
    synopsis: '江湖传言失传已久的剑谱重现，隐姓埋名的剑客被迫重出江湖。恩怨、家国与儿女情长在云雾缭绕的群山间徐徐展开。',
  },
  {
    id: 't02',
    title: '都市浮生记',
    category: 'tv',
    genres: ['都市', '剧情'],
    region: '中国',
    year: 2024,
    rating: 8.2,
    heat: 8120,
    cover: 'https://readdy.ai/api/search-image?query=modern%20urban%20drama%20series%20poster%20of%20a%20busy%20city%20skyline%20at%20dusk%20with%20warm%20apartment%20window%20lights%20deep%20blue%20evening%2C%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-14&orientation=portrait',
    director: '汪俊',
    actors: ['海清', '黄磊'],
    duration: '全36集',
    synopsis: '四位同住一栋老公寓的邻居，在房价、职场与亲情的夹缝中努力生活。平凡日常里的烟火气，正是这座城市最动人的底色。',
  },
  {
    id: 't03',
    title: '帝国残阳',
    category: 'tv',
    genres: ['历史', '战争'],
    region: '英国',
    year: 2023,
    rating: 9.1,
    heat: 7930,
    cover: 'https://readdy.ai/api/search-image?query=historical%20war%20drama%20poster%20of%20an%20ancient%20empire%20city%20at%20sunset%20with%20warm%20golden%20ruins%20dramatic%20deep%20blue%20sky%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-15&orientation=portrait',
    director: '汤姆·胡珀',
    actors: ['本尼迪克特·康伯巴奇', '克莱尔·芙伊'],
    duration: '全8集',
    synopsis: '一个庞大帝国走向衰落最后的十年。剧集以恢弘的场景与细腻的人物刻画，展现了权力更迭背后无数个体的命运。',
  },
  {
    id: 't04',
    title: '真相边缘',
    category: 'tv',
    genres: ['悬疑', '犯罪'],
    region: '韩国',
    year: 2024,
    rating: 8.7,
    heat: 9210,
    cover: 'https://readdy.ai/api/search-image?query=crime%20mystery%20series%20poster%20of%20a%20rainy%20korean%20city%20alley%20with%20neon%20reflections%20deep%20blue%20and%20warm%20orange%2C%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-16&orientation=portrait',
    director: '李应福',
    actors: ['李政宰', '金泰梨'],
    duration: '全16集',
    synopsis: '一名记者收到匿名举报，随着调查深入，他发现真相的每一步都踩在权力与谎言的边缘。反转迭起的犯罪悬疑佳作。',
  },
  {
    id: 't05',
    title: '硅谷风云',
    category: 'tv',
    genres: ['剧情', '都市'],
    region: '美国',
    year: 2024,
    rating: 8.4,
    heat: 7720,
    cover: 'https://readdy.ai/api/search-image?query=tech%20drama%20series%20poster%20of%20a%20modern%20glass%20office%20campus%20at%20blue%20hour%20with%20warm%20interior%20lights%2C%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-17&orientation=portrait',
    director: '迈克·乔吉',
    actors: ['拉米·马雷克', '赞达亚'],
    duration: '全10集',
    synopsis: '一家初创公司从车库里的小想法做到估值十亿。剧集用犀利又不失幽默的视角，讲述了科技浪潮下创业者的野心与困境。',
  },
  {
    id: 't06',
    title: '春日序曲',
    category: 'tv',
    genres: ['爱情', '都市'],
    region: '中国',
    year: 2024,
    rating: 8.3,
    heat: 7010,
    cover: 'https://readdy.ai/api/search-image?query=romantic%20urban%20drama%20poster%20of%20a%20couple%20in%20a%20spring%20street%20with%20cherry%20blossoms%20warm%20pink%20orange%20light%20soft%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-18&orientation=portrait',
    director: '李木戈',
    actors: ['杨紫', '张新成'],
    duration: '全32集',
    synopsis: '在春日开满樱花的街角，两位年轻人的生活因为一场误会而交汇。清新治愈的都市爱情，记录下一段关于勇气与相遇的序曲。',
  },
  {
    id: 't07',
    title: '极地迷航',
    category: 'tv',
    genres: ['冒险', '剧情'],
    region: '挪威',
    year: 2023,
    rating: 8.6,
    heat: 6240,
    cover: 'https://readdy.ai/api/search-image?query=arctic%20adventure%20series%20poster%20of%20an%20expedition%20ship%20in%20frozen%20polar%20landscape%20deep%20blue%20ice%20warm%20sunset%20glow%2C%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-19&orientation=portrait',
    director: '约阿希姆·蒂尔',
    actors: ['麦斯·米科尔森', '艾丽西亚·维坎德'],
    duration: '全6集',
    synopsis: '一支北极科考队在冰原深处失联，救援队必须在极昼与极寒中寻找他们。冰冷的极地风光下，是人性最炽热的求生意志。',
  },
  {
    id: 't08',
    title: '白色巨塔之下',
    category: 'tv',
    genres: ['医疗', '剧情'],
    region: '日本',
    year: 2024,
    rating: 8.8,
    heat: 8330,
    cover: 'https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%20of%20a%20hospital%20corridor%20with%20warm%20light%20and%20deep%20blue%20shadows%2C%20cinematic%20vertical%20composition%20elegant&width=400&height=600&seq=poster-20&orientation=portrait',
    director: '西谷弘',
    actors: ['织田裕二', '石原里美'],
    duration: '全12集',
    synopsis: '一位理想主义的年轻医生进入顶级医院，在救死扶伤的信念与体制的复杂之间不断挣扎。医疗题材的又一部深刻之作。',
  },
  {
    id: 't09',
    title: '追捕者',
    category: 'tv',
    genres: ['犯罪', '悬疑'],
    region: '中国',
    year: 2024,
    rating: 8.5,
    heat: 8840,
    cover: 'https://readdy.ai/api/search-image?query=crime%20thriller%20series%20poster%20of%20a%20city%20police%20chase%20at%20night%20with%20warm%20headlights%20and%20deep%20blue%20streets%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-21&orientation=portrait',
    director: '五百',
    actors: ['张译', '王千源'],
    duration: '全28集',
    synopsis: '一名经验老到的刑警与一个高智商逃犯展开跨越数年的猫鼠较量。每一次交锋，都是对信念与底线的考验。',
  },
  {
    id: 't10',
    title: '破碎的皇冠',
    category: 'tv',
    genres: ['奇幻', '古装'],
    region: '美国',
    year: 2023,
    rating: 8.9,
    heat: 8520,
    cover: 'https://readdy.ai/api/search-image?query=fantasy%20crown%20drama%20poster%20of%20a%20broken%20golden%20crown%20on%20a%20dark%20throne%20with%20warm%20candle%20glow%20deep%20blue%20shadows%2C%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-22&orientation=portrait',
    director: '米格尔·萨普什尼克',
    actors: ['艾米莉亚·克拉克', '基特·哈灵顿'],
    duration: '全9集',
    synopsis: '当王国的皇冠破碎，五大家族的继承人为了王座展开角逐。史诗般的奇幻世界，魔法、权谋与命运交织成恢弘群像。',
  },
  {
    id: 't11',
    title: '午夜电台',
    category: 'tv',
    genres: ['惊悚', '悬疑'],
    region: '中国',
    year: 2024,
    rating: 7.9,
    heat: 5610,
    cover: 'https://readdy.ai/api/search-image?query=thriller%20series%20poster%20of%20a%20vintage%20radio%20in%20a%20dark%20room%20with%20warm%20glow%20and%20deep%20blue%20night%20atmosphere%2C%20cinematic%20vertical%20art&width=400&height=600&seq=poster-23&orientation=portrait',
    director: '陈正道',
    actors: ['欧豪', '倪妮'],
    duration: '全24集',
    synopsis: '深夜电台主持人接到一通声称来自未来的电话，每当她说出一件事，第二天便应验。真相比想象中更加令人不寒而栗。',
  },
  {
    id: 't12',
    title: '远东来信',
    category: 'tv',
    genres: ['历史', '剧情'],
    region: '中国',
    year: 2023,
    rating: 8.6,
    heat: 6620,
    cover: 'https://readdy.ai/api/search-image?query=historical%20drama%20poster%20of%20an%20old%20letter%20and%20a%20train%20station%20at%20dawn%20warm%20golden%20light%20deep%20blue%20sky%2C%20cinematic%20vertical%20composition&width=400&height=600&seq=poster-24&orientation=portrait',
    director: '孔笙',
    actors: ['王凯', '佟丽娅'],
    duration: '全34集',
    synopsis: '上世纪三十年代，一封来自远东的家书牵出一段跨越战火的爱情与家国往事。时代洪流中，小人物的坚守格外动人。',
  },
];